import React, { Fragment, useCallback } from 'react';

import { useLocalizedStrings } from 'app/localization/Context';

import { ReactComponent as IconX } from 'images/general/x.svg';
import { ReactComponent as IconBack } from 'images/general/back.svg';
import { ReactComponent as IconTick } from 'images/general/tick.svg';
import { scenarioIcons } from 'app/model/Scenario';

export default function ChooseNameAndIcon(
    { dismissHandler, createCallback, back,
        setName, name, setIconId, iconId }) {

    const s = useLocalizedStrings();
    const sc = s.createScenarioProcess;

    const canCreate = name.length > 1;
    const onCreateClick = useCallback(() => {
        if (canCreate) {
            createCallback();
            dismissHandler();
        }
    }, [canCreate, createCallback, dismissHandler]);

    return (
        <div className="create-scenario-page-content">
            <IconBack className="nav-icon" /> <div className="nav-button" onClick={() => { back() ;}} />
            <IconX className="nav-icon-secondary" /> <div className="nav-button-secondary" onClick={dismissHandler} />

            <div className="header">{sc.giveNameAndIcon}</div>

            <div className="overview-lists-container">
                <ChooseNameAndIconInner
                    setName={setName} name={name}
                    setIconId={setIconId} iconId={iconId} />
            </div>

            {!canCreate ? <div className="error-label">{sc.youMustEnterAName}</div> : null}
            <div className="blue-button round-button"
                onClick={onCreateClick}
                style={{ opacity: canCreate ? 1 : 0.3 }}>
                <div>{sc.create}</div> <IconTick className="icon" />
            </div>
        </div >
    );
}


export function ChooseNameAndIconInner(
    { setName, name, setIconId, iconId }) {

    const s = useLocalizedStrings();
    const sc = s.createScenarioProcess;

    const _setIconId = useCallback((id) => {
        let oldPlaceHolder = sc.namePlaceHolders[iconId];
        if ((name.length === 0) || (name === oldPlaceHolder)) {
            setName(sc.namePlaceHolders[id]);
        }
        setIconId(id);
    }, [setIconId, name, sc.namePlaceHolders, iconId, setName]);

    return (
        <Fragment>
            <div className="section">
                <div className="header">
                    <div className="title bold-header">{sc.name}</div>
                </div>
                <div className="content">
                    <input className="name-input-box" placeholder={sc.namePlaceHolders[iconId]}
                        onChange={(e) => { setName(e.target.value) }} value={name}></input>
                </div>
            </div>

            {/* <div className="header-of-scenario-name-or-icon">{sc.name}</div>
            <input className="name-input-box" placeholder={sc.namePlaceHolders[iconId]}
                onChange={(e) => { setName(e.target.value) }} value={name}></input> */}

            <div className="section">
                <div className="header">
                    <div className="title bold-header">{sc.icon}</div>
                </div>
                <div className="content">
                    <div className="icon-list">

                        {
                            scenarioIcons.map((iconData, index) => {
                                let containerStyle = {};
                                let iconImage = iconData[1];
                                if (iconId === index + 1) {
                                    containerStyle = { borderColor: iconData[2] };
                                    iconImage = iconData[0];
                                }

                                return (
                                    <div
                                        onClick={() => {
                                            _setIconId(index + 1);
                                        }}
                                        className="icon-container"
                                        style={containerStyle}
                                        key={"create-scenario-icon-" + String(index)}>
                                        {React.createElement(iconImage, {
                                            className: "icon",
                                        })}
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>
            </div>

            {/* <div className="header-of-scenario-name-or-icon" style={{ marginTop: 16 }}>{sc.icon}</div>
            <div className="icon-list">
                {
                    scenarioIcons.map((iconData, index) => {
                        let containerStyle = {};
                        let iconImage = iconData[1];
                        if (iconId === index + 1) {
                            containerStyle = { borderColor: iconData[2] };
                            iconImage = iconData[0];
                        }

                        return (
                            <div
                                onClick={() => {
                                    _setIconId(index + 1);
                                }}
                                className="icon-container"
                                style={containerStyle}
                                key={"create-scenario-icon-" + String(index)}>
                                {React.createElement(iconImage, {
                                    className: "icon",
                                })}
                            </div>
                        );
                    })
                }
            </div>

            {!canCreate ? <div className="error-label">{sc.youMustEnterAName}</div> : null}
            <div className="blue-button round-button"
                onClick={onCreateClick}
                style={{ opacity: canCreate ? 1 : 0.3 }}>
                <div>{sc.create}</div> <IconTick className="icon" />
            </div>
        </div >
            </div> */}
        </Fragment>
    );
}